import { Box, Button, FormField, RangeInput, Text, TextInput } from "grommet"
import { Image } from "grommet-icons"
import RangeInputWithEdit from "../../../../forms/RangeInputWithEdit"
import MediaSelectModal from "../modal/MediaSelectModal"
import { useEffect, useState } from "react"
import ButtonInput from "../../../../forms/ButtonInput"
import { useTranslation } from "react-i18next"

export const ImageSettingsForm = ({ label, title, imageInputName, imageHueInputName, imageSaturationInputName, category }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField 
                label={label}
                name={imageInputName}
                className="no-border-form-field"
                component={(props) => <ButtonInput title={title} icon={<Image />} {...props} category={category} />}
            />
            <FormField label={t('hueLabel')} noBorder noFocus>
                <RangeInputWithEdit name={imageHueInputName} type="number" unit={'°'} min={0} max={360} step={1} />
            </FormField>
            <FormField label={t('saturationLabel')} noBorder noFocus >
                <RangeInputWithEdit name={imageSaturationInputName} type="number" unit={'%'} min={0} max={300} step={1} />
            </FormField>
        </Box>
    )
}